import { apiCall } from './generated/gqlClient';

const deleteInactiveSessionsApiRequest = async classId => {
  const mutation = `
    mutation deleteInactiveSessions($classId: Int!) {
      deleteInactiveSessions(classId: $classId) {
        id
        success
        message
      }
    }
  `;

  return apiCall({ query: mutation, variables: { classId: +classId } });
};

// Modifica sessioni N (#1713): the class's coming sessions from a day ("yyyy-MM-dd"), to an optional one:
// [{ id, startTime, endTime, capacity, capacityOverride, classCapacity, model, taken, waiting, staff: [{ id, name }] }]
// — `capacity` is the one in force: the session's own (capacityOverride) when set, else its class's.
const getSessionsForMultipleUpdateApiRequest = async ({ classId, fromDate, toDate }) =>
  apiCall({
    query: `
    query getSessionsForMultipleUpdate($classId: Int!, $fromDate: DateTime!, $toDate: DateTime) {
      getSessionsForMultipleUpdate(classId: $classId, fromDate: $fromDate, toDate: $toDate)
    }`,
    variables: { classId: +classId, fromDate, toDate: toDate || null },
  });

// Modifica sessioni N: [{ id, status: 'ok' | 'warning' | 'refused', staffBusy, customers: [names], error }].
// Each request: { id, startDate, startTime, endTime, resourceId } as updateSessionFromEvent takes them,
// plus `capacity` (the session's new capacity) or `resetCapacity` (back to the class's).
const checkMultipleSessionsUpdateApiRequest = async ({ requests }) =>
  apiCall({
    query: `
    query checkMultipleSessionsUpdate($requests: [SessionUpdateInput]!) {
      checkMultipleSessionsUpdate(requests: $requests)
    }`,
    variables: { requests },
  });

// Modifica sessioni N: saved one by one as the single edit: [{ id, success, error }].
const updateMultipleSessionsApiRequest = async ({ requests }) =>
  apiCall({
    query: `
    mutation updateMultipleSessions($requests: [SessionUpdateInput]!) {
      updateMultipleSessions(requests: $requests)
    }`,
    variables: { requests },
  });

export {
  checkMultipleSessionsUpdateApiRequest,
  deleteInactiveSessionsApiRequest,
  getSessionsForMultipleUpdateApiRequest,
  updateMultipleSessionsApiRequest,
};
